import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["title", "content"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Icon, { DownloadOutlined, EuroOutlined } from '@ant-design/icons';
import DixuAnchor from "../../components/DixuAnchor/DixuAnchor";
import { AppContext } from "../../components/DixuApp/DixuApp";
import DixuButton from "../../components/DixuButton/DixuButton";
import DixuCard from "../../components/DixuCard/DixuCard";
import DixuCardButton from "../../components/DixuCardButton/DixuCardButton";
import DixuCarousel from "../../components/DixuCarousel/DixuCarousel";
import DixuContactSellerModal from "../../components/DixuContactSellerModal/DixuContactSellerModal";
import DixuContainer from "../../components/DixuContainer/DixuContainer";
import DixuCreatePurchaseOfferModal from "../../components/DixuCreatePurchaseOfferModal/DixuCreatePurchaseOfferModal";
import DixuDescriptionList from "../../components/DixuDescriptionList/DixuDescriptionList";
import DixuDownloadFilesModal from "../../components/DixuDownloadFilesModal/DixuDownloadFilesModal";
import { DixuCol, DixuRow } from "../../components/DixuGrid/DixuGrid";
import DixuHead from "../../components/DixuHead/DixuHead";
import DixuImage from "../../components/DixuImage/DixuImage";
import DixuLink from "../../components/DixuLink/DixuLink";
import DixuListingPublishControls from "../../components/DixuListingPublishControls/DixuListingPublishControls";
import DixuLocationInfo from "../../components/DixuLocationInfo/DixuLocationInfo";
import DixuMortgageFormModal from "../../components/DixuMortgageFormModal/DixuMortgageFormModal";
import DixuNotification from "../../components/DixuNotification/DixuNotification";
import DixuRequestFileDownloadModal from "../../components/DixuRequestFileDownloadModal/DixuRequestFileDownloadModal";
import DixuReservePresentationModal from "../../components/DixuReservePresentationModal/DixuReservePresentationModal";
import DixuSellerCard from "../../components/DixuSellerCard/DixuSellerCard";
import DixuTag from "../../components/DixuTag/DixuTag";
import DixuText from "../../components/DixuText/DixuText";
import DixuTitle from "../../components/DixuTitle/DixuTitle";
import DixuTooltip from "../../components/DixuTooltip/DixuTooltip";
import useIsLoading from "../../hooks/useIsLoading";
import { useTranslation } from "../../i18n";
import { truncate } from 'lodash';
import { useRouter } from 'next/router';
import Area from "../../public/icons/area.svg";
import PriceTag from "../../public/icons/price_tag_eur.svg";
import RaisedHands from "../../public/icons/raised_hands.svg";
import React, { useContext, useEffect, useState } from 'react';
import { getErrorDescription, publishListing, redirect, reload } from "../../services/ApiService";
import { dateToFinnishFormat, timestampToDay } from "../../utils/DateTimeUtils";
import { LISTING_PROPERTY_TYPE, LISTING_STATUS, LISTING_TYPE, RELEASE, SERVICE_PACKAGE, LOT_OWNERSHIP } from "../../utils/DixuConstants";
import { canCreatePurchaseOffer, canDownloadDocuments, getAreaBasis, getContactRequestTel, getDisplayedArea, getEquipmentAndAdditionalDetails, getFireplaceType, getFloors, getFullStreetAddress, getHeatingSystem, getListingURL, getMaintenanceCharge, getNextPresentation, getPostalCodeDetails, getPricePerSquareMeter, getRoofType, getStreetAddress, getVideoUrl, getDealIncludes, getDealDoesNotInclude, isPlot, getOtherFees, getFlawsAndDamages, getBalconyDescription, isLotOwnershipRentOrOptional, getHousingCooperativeMortgageDate, getLotArea } from "../../utils/DixuListingUtils";
import { formatNumber, formatPrice, parseNumber } from "../../utils/MoneyUtils";
import { getReferrerPath, toQueryString } from "../../utils/RouterUtils";
import { getTranslationOrOther, getZoningStatus, translateArrayWithHumanize, translateBoolean } from "../../utils/TranslationUtils";
import { isValidURL, replaceLineBreaks, toRem } from "../../utils/Utils";
import { getVideoData } from "../../utils/VideoUtils";
import ScheduleIcon from "../../public/icons/schedule.svg";
import BuildingIcon from "../../public/icons/building.svg";
import CraneIcon from "../../public/icons/crane.svg";
import OpenHouseIcon from "../../public/icons/open_house.svg";
import WrenchIcon from "../../public/icons/wrench.svg";
import LotIcon from "../../public/icons/lot.svg";
import PlumbingIcon from "../../public/icons/plumbing.svg";
import LoanIcon from "../../public/icons/loan.svg";
import VirtualPresentationIcon from "../../public/icons/virtual-presentation.svg";
import NordeaIcon from "../../public/images/nordea.svg";
import ListingMarkerIcon from "../../public/icons/listing_marker.svg";
import IfIcon from "../../public/images/if.svg";
import theme from "../../SystemTheme";
const Carousel = _ref => {
  let {
    listing
  } = _ref;
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    0: videoData,
    1: setVideoData
  } = useState();
  const {
    virtualShowing,
    images,
    thumbnails
  } = listing || {};
  const videoUrl = getVideoUrl(listing);
  const carouselProps = {
    slides: [(() => {
      if (isValidURL(virtualShowing)) {
        return {
          stickyThumbnail: true,
          thumbnailContent: /*#__PURE__*/React.createElement(DixuLink, {
            href: virtualShowing,
            external: true,
            color: "2-1"
          }, /*#__PURE__*/React.createElement(DixuRow, {
            justify: "center",
            align: "middle",
            className: "mobile-p-t-8 mobile-p-r-8 mobile-p-l-8",
            style: {
              height: '100%'
            }
          }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuRow, {
            justify: "center",
            gutter: [0, 8]
          }, /*#__PURE__*/React.createElement(DixuCol, {
            span: 24
          }, /*#__PURE__*/React.createElement(VirtualPresentationIcon, {
            style: {
              height: toRem(48)
            }
          })), /*#__PURE__*/React.createElement(DixuCol, {
            span: 24
          }, t('listing:VirtualPresentation'))))))
        };
      }
      return null;
    })(), (() => {
      if (videoData) {
        return {
          src: videoUrl,
          thumbnailSrc: videoData?.thumbnail,
          videoProvider: videoData?.provider
        };
      }
      return null;
    })()].concat(images?.map((image, index) => {
      return {
        src: image.compressed,
        thumbnailSrc: thumbnails?.[index],
        description: image.description
      };
    })).filter(Boolean)
  };
  useEffect(() => {
    if (!videoUrl) {
      return undefined;
    }
    let isMounted = true;
    (async () => {
      const data = await getVideoData(videoUrl);
      if (isMounted) {
        setVideoData(data);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "dixu-listing-screen__carousel-wrapper"
  }, /*#__PURE__*/React.createElement(DixuCarousel, _objectSpread(_objectSpread({}, carouselProps), {}, {
    portal: false
  })));
};
const HeroSection = _ref2 => {
  let {
    listing,
    documents,
    ifLoggedIn
  } = _ref2;
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    0: documentDownloadModalVisible,
    1: setDocumentDownloadModalVisible
  } = useState(!!documents);
  const {
    0: requestDocumentDownloadModalVisible,
    1: setRequestDocumentDownloadModalVisible
  } = useState(false);
  const {
    0: purchaseOfferModalVisible,
    1: setPurchaseOfferModalVisible
  } = useState(false);
  const {
    area,
    bidding,
    completeYear,
    debtFreePrice,
    floorPlans,
    fundingCharge,
    housingCooperativeUpcomingRenovations,
    listingType,
    lotOwnership,
    maintenanceCharge,
    mandatoryCharges,
    otherCharge,
    pastRenovations,
    pipeRenovationYear,
    renovationCharge,
    plotRentCharge,
    typeOfApartment
  } = listing || {};
  const hasFloorPlans = !!floorPlans?.length;
  const pastRenovationsText = pastRenovations;
  const upcomingRenovationsText = housingCooperativeUpcomingRenovations;
  const hasRenovations = pastRenovationsText || upcomingRenovationsText;
  const biddingURL = getListingURL(listing, {
    modifier: 'bidding'
  });
  const {
    latestOfferPrice,
    debtlessStartPrice
  } = bidding || {};
  const biddingLatestOfferPricePerSquareMeter = formatPrice(getPricePerSquareMeter(listing, latestOfferPrice));
  const biddingStartPricePerSquareMeter = formatPrice(getPricePerSquareMeter(listing, debtlessStartPrice));
  const streetAddress = getStreetAddress(listing);
  const postalCodeDetails = getPostalCodeDetails(listing);
  const pricePerSquareMeter = formatPrice(getPricePerSquareMeter(listing));
  const displayedArea = getDisplayedArea({
    listing,
    t
  });
  const nextPublicPresentation = getNextPresentation({
    listing,
    publicOnly: true,
    t
  });
  const maintenanceChargeSeparated = getMaintenanceCharge(listing, t);
  const files = Object.entries((documents || []).map(doc => {
    const {
      type,
      filename,
      fd,
      downloadUrl
    } = doc;
    return {
      category: t(`common:DocumentTypes.${type}`),
      items: [{
        name: filename,
        url: downloadUrl
      }]
    };
  }).reduce((acc, file) => {
    const {
      category,
      items
    } = file;
    return _objectSpread(_objectSpread({}, acc), {}, {
      [category]: [...(acc[category] || []), ...items]
    });
  }, {})).map(_ref3 => {
    let [category, items] = _ref3;
    return {
      category,
      items
    };
  });
  const basicInfoSummaryItems = [{
    icon: /*#__PURE__*/React.createElement(BuildingIcon, {
      style: {
        height: toRem(32)
      }
    }),
    name: t('listing:ListingDetails.ListingType'),
    value: t(`common:ListingTypes.${listingType}`),
    condition: !!listingType
  }, {
    icon: /*#__PURE__*/React.createElement(CraneIcon, {
      style: {
        height: toRem(32)
      }
    }),
    name: t('listing:ListingDetails.ConstructionYear'),
    value: completeYear,
    condition: !!completeYear
  }, {
    icon: /*#__PURE__*/React.createElement(OpenHouseIcon, {
      style: {
        height: toRem(32)
      }
    }),
    name: t('listing:MyListing.NextPresentation'),
    value: nextPublicPresentation,
    excludeFromFilter: true,
    placeholder: t('common:NotKnown')
  }, {
    icon: /*#__PURE__*/React.createElement(WrenchIcon, {
      style: {
        height: toRem(32)
      }
    }),
    name: (() => {
      if ([mandatoryCharges, fundingCharge, renovationCharge, plotRentCharge, otherCharge].some(Boolean)) {
        return /*#__PURE__*/React.createElement(DixuTooltip.Info, {
          title: maintenanceChargeSeparated,
          iconProps: {
            font: '3'
          },
          iconPlacement: 'end',
          overlayWidth: 450
        }, t('listing:ListingDetails.MaintenanceCharge'));
      }
      return t('listing:ListingDetails.MaintenanceCharge');
    })(),
    value: formatPrice(maintenanceCharge),
    valueSuffix: t('common:Suffixes.PerMonth'),
    condition: !!maintenanceChargeSeparated && !!Number(maintenanceCharge)
  }, {
    icon: /*#__PURE__*/React.createElement(LotIcon, {
      style: {
        height: toRem(32)
      }
    }),
    name: t('listing:ListingDetails.Lot'),
    value: t(`common:LotOwnershipTypes.${lotOwnership}`),
    condition: !!lotOwnership
  }, {
    icon: /*#__PURE__*/React.createElement(PlumbingIcon, {
      style: {
        height: toRem(32)
      }
    }),
    name: t('listing:ListingDetails.Pipes'),
    value: pipeRenovationYear,
    condition: !!pipeRenovationYear
  }];
  const sectionLinks = [{
    label: t('listing:ListingDetails.Location'),
    href: '#location-info'
  }, {
    label: t('listing:ListingDetails.Introduction'),
    href: '#introduction'
  }, {
    label: t('listing:ListingDetails.FloorPlan'),
    href: '#floor-plan',
    condition: hasFloorPlans
  }, {
    label: t('listing:ListingDetails.ListingTitle'),
    href: '#property-info'
  }, {
    label: t('listing:ListingDetails.HousingCoopAndProperty'),
    href: '#housing-coop'
  }, {
    label: t('listing:ListingDetails.Renovations'),
    href: '#renovations',
    condition: hasRenovations
  }].filter(link => {
    const {
      condition: linkCondition
    } = link;
    return typeof linkCondition === 'undefined' ? true : linkCondition;
  });
  const mappedSectionLinksMobile = [{
    label: t('listing:ListingDetails.Images'),
    href: '#images'
  }, ...sectionLinks].map(link => {
    const {
      href,
      label
    } = link;
    return /*#__PURE__*/React.createElement(DixuAnchor.Link, {
      key: label,
      href: href,
      title: label
    });
  });
  const mappedSectionLinks = sectionLinks.map(link => {
    const {
      href,
      label
    } = link;
    return /*#__PURE__*/React.createElement(DixuButton, {
      key: label,
      type: "link",
      size: "lg",
      href: href,
      weight: "bold"
    }, label);
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuAnchor, {
    type: "tabs",
    replaceHistory: true,
    className: "desktop-hidden"
  }, mappedSectionLinksMobile), /*#__PURE__*/React.createElement("section", {
    className: "dixu-listing-screen__hero box-shadow-2 bg-2-1",
    id: "images"
  }, /*#__PURE__*/React.createElement(DixuContainer, {
    maxWidth: "xxl",
    horizontalPadding: "lg",
    verticalPadding: "lg",
    height: "full-view",
    centerVertically: true
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [32, 32]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 15
  }, /*#__PURE__*/React.createElement(Carousel, {
    listing: listing
  })), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 9,
    flex: 1
  }, /*#__PURE__*/React.createElement("div", {
    className: "dixu-listing-screen__basic-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dixu-listing-screen__basic-info-section"
  }, /*#__PURE__*/React.createElement("div", null, bidding && /*#__PURE__*/React.createElement(DixuTitle, {
    level: "5",
    color: "1-6",
    weight: "bold",
    noSemantics: true
  }, /*#__PURE__*/React.createElement(DixuLink, {
    href: biddingURL
  }, /*#__PURE__*/React.createElement(DixuRow, {
    align: "middle",
    gutter: 14,
    wrap: false
  }, /*#__PURE__*/React.createElement(DixuCol, null, t('listing:ListingDetails.BiddingListing'))))), /*#__PURE__*/React.createElement(DixuTitle, {
    level: "1",
    weight: "bold"
  }, streetAddress), /*#__PURE__*/React.createElement(DixuTitle, {
    level: "2",
    weight: "medium",
    noSemantics: true
  }, postalCodeDetails), /*#__PURE__*/React.createElement(DixuTitle, {
    level: "4",
    weight: "medium",
    noSemantics: true,
    wrap: true
  }, typeOfApartment)), /*#__PURE__*/React.createElement("div", null, bidding && /*#__PURE__*/React.createElement(DixuDescriptionList, {
    vertical: true,
    className: "m-b-8",
    hideFiltered: false,
    nameProps: {
      font: '2',
      color: '2-6'
    },
    items: [{
      icon: /*#__PURE__*/React.createElement(RaisedHands, {
        style: {
          width: toRem(24),
          height: toRem(24)
        }
      }),
      name: /*#__PURE__*/React.createElement(DixuLink, {
        href: biddingURL
      }, t('listing:ListingDetails.LatestOffer')),
      value: /*#__PURE__*/React.createElement(DixuTitle, {
        level: "3",
        noSemantics: true,
        weight: "bold",
        margin: "0"
      }, /*#__PURE__*/React.createElement(DixuLink, {
        href: biddingURL
      }, formatPrice(latestOfferPrice), ' ', /*#__PURE__*/React.createElement(DixuText, {
        font: "3",
        weight: "normal",
        margin: "0"
      }, "(", biddingLatestOfferPricePerSquareMeter, ' ', t('common:Suffixes.PerSquareMeter'), ")"))),
      placeholder: /*#__PURE__*/React.createElement(DixuLink, {
        href: biddingURL
      }, t('listing:ListingDetails.NoOffersYet')),
      condition: latestOfferPrice != null,
      itemProps: {
        style: {
          marginBottom: toRem(16)
        }
      }
    }, {
      icon: /*#__PURE__*/React.createElement(PriceTag, {
        style: {
          opacity: 0.4,
          color: theme.token.colorPrimary,
          width: toRem(24),
          height: toRem(24)
        }
      }),
      iconProps: {
        fill: '1-6'
      },
      name: t('listing:ListingDetails.DebtFreeStartPrice'),
      value: /*#__PURE__*/React.createElement(DixuTitle, {
        level: "3",
        noSemantics: true,
        weight: "bold",
        margin: "0"
      }, formatPrice(debtlessStartPrice), ' ', listing.type !== LISTING_TYPE.PROPERTY && /*#__PURE__*/React.createElement(DixuText, {
        font: "3",
        weight: "normal",
        style: {
          opacity: 0.4
        }
      }, "(", biddingStartPricePerSquareMeter, ' ', t('common:Suffixes.PerSquareMeter'), ")")),
      condition: !!debtlessStartPrice,
      itemProps: {
        className: 'p-b-24'
      }
    }]
  }), !bidding && /*#__PURE__*/React.createElement(DixuTitle, {
    level: "3",
    noSemantics: true,
    weight: "bold",
    "aria-label": t('listing:ListingDetails.DebtlessPrice')
  }, /*#__PURE__*/React.createElement(DixuRow, {
    align: "middle",
    gutter: 14,
    wrap: false
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
    font: "5",
    color: "1-6",
    flexbox: true,
    block: true
  }, /*#__PURE__*/React.createElement(Icon, {
    style: {
      opacity: 0.4
    },
    component: PriceTag
  }))), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
    font: "5"
  }, formatPrice(debtFreePrice), ' '), listing.type !== LISTING_TYPE.PROPERTY && area && /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    weight: "medium",
    style: {
      opacity: 0.4
    }
  }, "(", pricePerSquareMeter, ' ', t('common:Suffixes.PerSquareMeter'), ")")))), displayedArea && /*#__PURE__*/React.createElement(DixuTitle, {
    level: "5",
    margin: "0",
    noSemantics: true,
    "aria-label": t(isPlot(listing) ? 'listing:ListingDetails.PlotArea' : 'listing:ListingDetails.Area')
  }, /*#__PURE__*/React.createElement(DixuRow, {
    align: "middle",
    gutter: 14,
    wrap: false
  }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
    font: "5",
    flexbox: true,
    block: true
  }, /*#__PURE__*/React.createElement(Icon, {
    component: Area
  }))), /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement(DixuText, {
    weight: "medium"
  }, displayedArea))))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DixuRow, null, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    md: 18,
    xl: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [24, 24]
  }, /*#__PURE__*/React.createElement(DixuDescriptionList, {
    items: basicInfoSummaryItems,
    filter: true,
    vertical: true,
    nameProps: {
      font: '2',
      color: '2-6'
    },
    columns: 2,
    colProps: {
      xs: 24,
      md: 12
    }
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "dixu-listing-screen__basic-info-section"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DixuButton.Group, {
    spacing: "lg"
  }, canDownloadDocuments(listing) && /*#__PURE__*/React.createElement(DixuButton, {
    type: "ghost",
    size: "lg",
    icon: /*#__PURE__*/React.createElement(DownloadOutlined, null),
    onClick: () => {
      ifLoggedIn(() => {
        if (documents) {
          setDocumentDownloadModalVisible(true);
        } else {
          setRequestDocumentDownloadModalVisible(true);
        }
      });
    }
  }, t('listing:DownloadSalesLeaflet')), bidding && /*#__PURE__*/React.createElement(DixuButton, {
    type: "primary",
    size: "lg",
    icon: /*#__PURE__*/React.createElement(EuroOutlined, null),
    href: biddingURL
  }, t('listing:Bidding.FollowBidding')), !bidding && canCreatePurchaseOffer(listing) && /*#__PURE__*/React.createElement(DixuButton, {
    type: "primary",
    size: "lg",
    icon: /*#__PURE__*/React.createElement(EuroOutlined, null),
    onClick: () => {
      ifLoggedIn(() => {
        setPurchaseOfferModalVisible(true);
      });
    }
  }, t('listing:MakeBuyingOffer'))))))), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 0,
    xl: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center"
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 20
  }, /*#__PURE__*/React.createElement("nav", {
    className: "dixu-listing-screen__section-links",
    "aria-label": "Sections"
  }, mappedSectionLinks)))))), /*#__PURE__*/React.createElement(DixuDownloadFilesModal, {
    title: t('listing:ListingDocuments'),
    emptyDescription: t('listing:NoDocuments'),
    visible: documentDownloadModalVisible,
    onCancel: () => setDocumentDownloadModalVisible(false),
    onOk: () => setDocumentDownloadModalVisible(false),
    files: files
  }), /*#__PURE__*/React.createElement(DixuRequestFileDownloadModal, {
    listing: listing,
    visible: requestDocumentDownloadModalVisible,
    onCancel: () => setRequestDocumentDownloadModalVisible(false),
    onSubmit: () => setRequestDocumentDownloadModalVisible(false)
  }), /*#__PURE__*/React.createElement(DixuCreatePurchaseOfferModal, {
    listing: listing,
    visible: purchaseOfferModalVisible,
    onCancel: () => setPurchaseOfferModalVisible(false)
  })));
};
const ActionButtonsSection = _ref4 => {
  let {
    listing,
    ifLoggedIn
  } = _ref4;
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    0: privatePreservationsModalVisible,
    1: setPrivatePresentationModalVisible
  } = useState(false);
  const {
    0: mortgageFormVisible,
    1: setMortgageFormVisible
  } = useState(false);
  const nextPublicPresentation = getNextPresentation({
    listing,
    publicOnly: true,
    t
  });
  const actionButtons = [{
    icon: /*#__PURE__*/React.createElement(ScheduleIcon, null),
    title: t('listing:NextPublicPresentation'),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, !!nextPublicPresentation && nextPublicPresentation, !nextPublicPresentation && t('common:NotKnown')),
    disabled: true,
    subtleDisabled: true,
    onClick: () => ifLoggedIn(() => setPrivatePresentationModalVisible(true))
  }, {
    icon: /*#__PURE__*/React.createElement(LoanIcon, null),
    title: t('listing:SeekMortgage'),
    content: /*#__PURE__*/React.createElement(DixuRow, {
      align: "middle",
      gutter: [8, 8]
    }, /*#__PURE__*/React.createElement(DixuCol, null, /*#__PURE__*/React.createElement("span", {
      className: "vhidden"
    }, "Nordea"), /*#__PURE__*/React.createElement(NordeaIcon, {
      style: {
        height: toRem(16)
      }
    }))),
    onClick: () => setMortgageFormVisible(true)
  }].map(data => {
    const {
        title,
        content
      } = data,
      rest = _objectWithoutProperties(data, _excluded);
    return /*#__PURE__*/React.createElement(DixuCardButton, _objectSpread({
      key: title,
      title
    }, rest), content);
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuCardButton.Group, null, actionButtons), /*#__PURE__*/React.createElement(DixuReservePresentationModal, {
    listing: listing,
    visible: privatePreservationsModalVisible,
    onOk: () => {
      setPrivatePresentationModalVisible(false);
      reload();
    },
    onCancel: () => setPrivatePresentationModalVisible(false)
  }), /*#__PURE__*/React.createElement(DixuMortgageFormModal, {
    listing: listing,
    visible: mortgageFormVisible,
    onOk: () => {
      setMortgageFormVisible(false);
      reload();
    },
    onCancel: () => setMortgageFormVisible(false)
  }));
};
const SellerSection = _ref5 => {
  let {
    listing,
    ifLoggedIn
  } = _ref5;
  const {
    0: messageFormVisible,
    1: setMessageFormVisible
  } = useState(false);
  const {
    realtor,
    selfSeller,
    servicePackage
  } = listing || {};
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuSellerCard, {
    listing: listing,
    seller: servicePackage === SERVICE_PACKAGE.DIXU_EASY ? selfSeller : realtor,
    contactRequestTel: getContactRequestTel(listing),
    servicePackage: servicePackage,
    onContact: () => {
      ifLoggedIn(() => {
        setMessageFormVisible(true);
      });
    }
  }), /*#__PURE__*/React.createElement(DixuContactSellerModal, {
    listing: listing,
    visible: messageFormVisible,
    onOk: () => setMessageFormVisible(false),
    onCancel: () => setMessageFormVisible(false)
  }));
};
const MapSection = _ref6 => {
  let {
    listing
  } = _ref6;
  return /*#__PURE__*/React.createElement(DixuLocationInfo, {
    id: "location-info",
    locations: [{
      name: /*#__PURE__*/React.createElement(ListingMarkerIcon, {
        style: {
          height: toRem(21)
        }
      }),
      value: 'Asunto'
    }],
    listing: listing,
    defaultExpanded: false,
    collapsible: true
  });
};
const IntroductionSection = _ref7 => {
  let {
    listing
  } = _ref7;
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    freeTextTitle,
    freeText
  } = listing || {};
  const trimmedTitle = freeTextTitle?.trim();
  return /*#__PURE__*/React.createElement(DixuCard, {
    title: t('listing:ListingDetails.ListingIntroduction'),
    contentProps: {
      whiteSpace: 'pre-line'
    },
    collapsible: ['mobile'],
    id: "introduction"
  }, trimmedTitle && /*#__PURE__*/React.createElement(DixuTitle, {
    level: "4",
    weight: "bold",
    noSemantics: true
  }, trimmedTitle), /*#__PURE__*/React.createElement(DixuText, {
    weight: "medium"
  }, freeText?.trim() || null));
};
const FloorPlansSection = _ref8 => {
  let {
    listing
  } = _ref8;
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    floorPlans
  } = listing || {};
  return /*#__PURE__*/React.createElement(DixuCard, {
    title: t('listing:ListingDetails.FloorPlan'),
    collapsible: ['mobile'],
    id: "floor-plan"
  }, floorPlans?.map((floorPlan, index) => {
    return /*#__PURE__*/React.createElement(DixuImage, {
      key: `floorPlanImage-${index}`,
      src: floorPlan.compressed,
      aspectRatio: "4:3",
      fit: "contain"
    });
  }));
};
const LiftsSection = _ref9 => {
  let {
    listing
  } = _ref9;
  const {
    t
  } = useTranslation(['common', 'listing']);
  const {
    lifts
  } = listing || {};
  const mappedLifts = lifts?.map((lift, index) => {
    return /*#__PURE__*/React.createElement(DixuCol, {
      key: index.toString(36),
      span: 24
    }, /*#__PURE__*/React.createElement(DixuTag, {
      textProps: {
        font: '5',
        color: '1-7'
      },
      background: "1-1",
      borderColor: "1-3"
    }, lift));
  });
  return /*#__PURE__*/React.createElement(DixuCard, {
    title: t('listing:ListingDetails.Lifts'),
    collapsible: ['mobile']
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 16],
    style: {
      margin: 0
    }
  }, mappedLifts));
};
const BasicInfoSection = _ref10 => {
  let {
    listing
  } = _ref10;
  const {
    t,
    i18n
  } = useTranslation(['common', 'listing']);
  const {
    area,
    areaMoreInfo,
    completeYear,
    constructionYearInfo,
    deploymentYear,
    freeOnText,
    listingType,
    newDevelopmentStatus,
    otherArea,
    otherReleaseCondition,
    overallArea,
    ownershipType,
    release,
    releaseDate,
    roomCount,
    soldAsRented
  } = listing || {};
  const fullStreetAddress = getFullStreetAddress(listing);
  const areaBasis = getAreaBasis(listing, {
    t,
    i18n
  });
  const basicInfoItems = [{
    name: t('listing:ListingDetails.Location'),
    value: fullStreetAddress,
    condition: !!fullStreetAddress
  }, {
    name: t('listing:ListingDetails.OwnershipType'),
    value: t(`listing:OwnershipType.${ownershipType}`),
    condition: !!ownershipType
  }, {
    name: t('listing:ListingDetails.RoomCount'),
    value: roomCount
  }, {
    name: t('listing:ListingDetails.Area'),
    value: t('common:Units.SquareMeters', {
      area: formatNumber(area)
    }),
    condition: !!area
  }, {
    name: t('listing:ListingDetails.OtherArea'),
    value: t('common:Units.SquareMeters', {
      area: formatNumber(otherArea)
    }),
    condition: !!otherArea
  }, {
    name: t('listing:ListingDetails.OverallArea'),
    value: t('common:Units.SquareMeters', {
      area: formatNumber(overallArea)
    }),
    condition: !!overallArea
  }, {
    name: t('listing:ListingDetails.AreaBasis'),
    value: areaBasis
  }, {
    name: t('listing:ListingDetails.AreaMoreInfo'),
    value: areaMoreInfo
  }, {
    name: t('listing:ListingDetails.ListingType'),
    value: t(`common:ListingTypes.${listingType}`),
    condition: !!listingType
  }, {
    name: t('listing:ListingDetails.Floor'),
    value: getFloors(listing)
  }, {
    name: t('listing:ListingDetails.ConstructionYear'),
    value: completeYear
  }, {
    name: t('listing:ListingDetails.ConstructionYearInfo'),
    value: constructionYearInfo
  }, {
    name: t('listing:ListingDetails.DeploymentYear'),
    value: deploymentYear
  }, {
    name: t('listing:ListingDetails.NewDevelopmentStatus'),
    value: t(`listing:NewDevelopmentStatusTypes.${newDevelopmentStatus}`),
    condition: !!newDevelopmentStatus
  }, {
    name: t('listing:ListingDetails.SoldAsRented'),
    value: soldAsRented ? t('common:Yes') : t('common:No')
  }, {
    name: t('listing:ListingDetails.Availability'),
    value: (() => {
      if (release === RELEASE.DATE) {
        return releaseDate ? timestampToDay(releaseDate) : null;
      }
      if (release === RELEASE.OTHER) {
        return otherReleaseCondition || null;
      }
      return t(`common:FreeOnTypes.${release}`);
    })(),
    condition: !!release
  }, {
    name: t('listing:ListingDetails.AvailabilityDetails'),
    value: freeOnText
  }];
  return /*#__PURE__*/React.createElement(DixuCard, {
    id: "property-info",
    title: t('listing:ListingDetails.BasicInfo'),
    collapsible: ['mobile']
  }, /*#__PURE__*/React.createElement(DixuDescriptionList, {
    items: basicInfoItems,
    filter: true,
    vertical: ['mobile']
  }));
};
const ExpensesSection = _ref11 => {
  let {
    listing
  } = _ref11;
  const {
    t,
    i18n
  } = useTranslation(['common', 'listing']);
  const {
    averageTotalHeatingCharge,
    burden,
    debt,
    debtFreePrice,
    electricHeatingCharge,
    electricHeatingPowerUsage,
    electricPlanTransfers,
    listingType,
    mortgage,
    nonElectricHeatingCharge,
    otherPlanTransfers,
    parkingCharge,
    propertyTax,
    roadTolls,
    sanitationCharge,
    satelliteCableTVCharge,
    saunaCharge,
    saunaChargeType,
    waterAndSewageCharge,
    waterCharge,
    waterChargeType,
    otherChargeDescription
  } = listing || {};
  const pricePerSquareMeter = formatPrice(getPricePerSquareMeter(listing));
  const maintenanceChargeSeparated = getMaintenanceCharge(listing, t);
  const homeInsuranceHref = (() => {
    if ([LISTING_PROPERTY_TYPE.FLAT, LISTING_PROPERTY_TYPE.ROWHOUSE, LISTING_PROPERTY_TYPE.PAIRHOUSE, LISTING_PROPERTY_TYPE.LOFT].includes(listingType)) {
      return 'https://www.if.fi/henkiloasiakkaat/vakuutukset/kotivakuutus/kerrostalo-rivitalo?as=free1start&utm_source=linear&utm_medium=link&utm_campaign=fi_if_b2c_harvest_property_householder';
    }
    if ([LISTING_PROPERTY_TYPE.DETACHEDHOUSE, LISTING_PROPERTY_TYPE.SEPARATEHOUSE].includes(listingType)) {
      return 'https://www.if.fi/henkiloasiakkaat/vakuutukset/kotivakuutus/omakotitalo?as=free1start&utm_source=linear&utm_medium=link&utm_campaign=fi_if_b2c_harvest_property_homeowner';
    }
    return null;
  })();
  const expensesItems = [{
    name: t('listing:ListingDetails.DebtlessPrice'),
    value: formatPrice(debtFreePrice),
    condition: ![LISTING_PROPERTY_TYPE.DETACHEDHOUSE].includes(listingType)
  }, {
    name: t('listing:ListingDetails.AskPrice'),
    value: formatPrice(parseNumber(debtFreePrice) - parseNumber(debt))
  }, {
    name: t('listing:ListingDetails.DebtAmount'),
    value: formatPrice(debt)
  }, {
    name: t('listing:ListingDetails.ElectricHeatingPowerUsage'),
    value: t('common:Units.kWhPerYear', {
      amount: parseNumber(electricHeatingPowerUsage)
    }),
    condition: !!electricHeatingPowerUsage
  }, {
    name: t('listing:ListingDetails.NonElectricHeatingCharge'),
    value: formatPrice(nonElectricHeatingCharge)
  }, {
    name: t('listing:ListingDetails.ElectricHeatingCharge'),
    value: t('common:Units.EURPerMonth', {
      amount: formatPrice(electricHeatingCharge, {
        noSymbol: true
      })
    }),
    condition: !!electricHeatingCharge
  }, {
    name: t('listing:ListingDetails.AverageTotalHeatingCharge'),
    value: formatPrice(averageTotalHeatingCharge),
    valueSuffix: t('common:Suffixes.PerMonth')
  }, {
    name: t('listing:ListingDetails.MaintenanceCharge'),
    value: maintenanceChargeSeparated
  }, {
    name: t('listing:ListingDetails.OtherChargeDetails'),
    value: otherChargeDescription
  }, {
    name: t('listing:ListingDetails.ParkingCharge'),
    value: formatPrice(parkingCharge),
    valueSuffix: t('common:Suffixes.PerMonth'),
    condition: !!parkingCharge
  }, {
    name: t('listing:ListingDetails.SaunaCharge'),
    value: formatPrice(saunaCharge),
    valueSuffix: t([`common:Suffixes.${saunaChargeType}`, 'common:Suffixes.PerMonth'])
  }, {
    name: t('listing:ListingDetails.WaterCharge'),
    value: waterCharge,
    valueSuffix: waterChargeType ? t(`listing:WaterChargeTypes.${waterChargeType}`) : t('common:Suffixes.PerMonth'),
    condition: !!waterCharge
  }, {
    name: t('listing:ListingDetails.WaterAndSewageCharge'),
    value: formatPrice(waterAndSewageCharge)
  }, {
    name: t('listing:ListingDetails.SanitationCharge'),
    value: formatPrice(sanitationCharge)
  }, {
    name: t('listing:ListingDetails.RoadTolls'),
    value: formatPrice(roadTolls)
  }, {
    name: t('listing:ListingDetails.SatelliteCableTVCharge'),
    value: formatPrice(satelliteCableTVCharge)
  }, {
    name: t('listing:ListingDetails.PropertyTax'),
    value: formatPrice(propertyTax)
  }, {
    name: t('listing:ListingDetails.Mortgage'),
    value: formatPrice(mortgage)
  }, {
    name: t('listing:ListingDetails.Burden'),
    value: burden
  }, {
    name: t('listing:ListingDetails.ElectricPlanTransfers'),
    value: translateBoolean(electricPlanTransfers, {
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.OtherPlanTransfers'),
    value: otherPlanTransfers
  }, {
    name: t('listing:ListingDetails.SquareFootPrice'),
    value: pricePerSquareMeter,
    valueSuffix: t('common:Suffixes.PerSquareMeter'),
    condition: !!listing?.area
  }, {
    name: t('listing:ListingDetails.ChargeDetails'),
    value: getOtherFees({
      listing,
      t
    })
  }, {
    condition: !!homeInsuranceHref,
    name: t('listing:ListingDetails.HomeInsurance'),
    value: /*#__PURE__*/React.createElement(DixuLink, {
      id: "public-listing-page-if-insurance-link",
      href: homeInsuranceHref,
      external: true,
      className: "dixu-listing-screen__if-insurance-cta"
    }, /*#__PURE__*/React.createElement(DixuRow, {
      type: "inline",
      align: "middle",
      gutter: 8,
      wrap: false
    }, /*#__PURE__*/React.createElement(DixuCol, {
      flex: true
    }, /*#__PURE__*/React.createElement(DixuButton, {
      type: "ghost",
      tabindex: "-1"
    }, t('listing:InsuranceCalculator.CalculatePriceEstimate'))), /*#__PURE__*/React.createElement(DixuCol, {
      style: {
        display: 'flex'
      }
    }, /*#__PURE__*/React.createElement(IfIcon, {
      style: {
        height: toRem(32)
      }
    }))))
  }];
  return /*#__PURE__*/React.createElement(DixuCard, {
    title: t('listing:ListingDetails.PriceAndExpenses'),
    collapsible: ['mobile']
  }, /*#__PURE__*/React.createElement(DixuDescriptionList, {
    items: expensesItems,
    filter: true,
    vertical: ['mobile']
  }));
};
const FacilitiesAndMaterialsSection = _ref12 => {
  let {
    listing
  } = _ref12;
  const {
    t,
    i18n
  } = useTranslation(['common', 'listing']);
  const {
    bathroomDescription,
    bathroomEquipment,
    otherBathroomEquipment,
    bathroomEquipmentDetails,
    bathroomFloorMaterial,
    otherBathroomFloorMaterial,
    bathroomWallMaterial,
    otherBathroomWallMaterial,
    bedroomCount,
    bedroomDescription,
    bedroomEquipment,
    bedroomFloorMaterial,
    otherBedroomFloorMaterial,
    bedroomWallMaterial,
    otherBedroomWallMaterial,
    kitchenDescription,
    kitchenEquipment,
    otherKitchenEquipment,
    kitchenEquipmentDetails,
    kitchenFloorMaterial,
    otherKitchenFloorMaterial,
    kitchenWallMaterial,
    otherKitchenWallMaterial,
    kitchenWorkTop,
    otherKitchenWorkTop,
    livingRoomDescription,
    livingRoomFloorMaterial,
    otherLivingRoomFloorMaterial,
    livingRoomWallMaterial,
    otherLivingRoomWallMaterial,
    sauna,
    saunaDescription,
    saunaFloorMaterial,
    otherSaunaFloorMaterial,
    saunaStoveType,
    otherSaunaStoveType,
    saunaWallMaterial,
    otherSaunaWallMaterial,
    storageDescription,
    storageSpaceTypes,
    otherStorageSpaceTypes,
    stoveType,
    otherStoveType,
    utilityRoomDescription,
    utilityRoomEquipment,
    otherUtilityRoomEquipment,
    utilityRoomEquipmentDetails,
    utilityRoomFloorMaterial,
    otherUtilityRoomFloorMaterial,
    utilityRoomHasExit,
    utilityRoomWallMaterial,
    otherUtilityRoomWallMaterial,
    wcCount,
    wcDescription,
    wcEquipment,
    otherWcEquipment,
    wcEquipmentDetails,
    wcFloorMaterial,
    otherWcFloorMaterial,
    wcWallMaterial,
    otherWcWallMaterial
  } = listing || {};
  const fireplaceType = getFireplaceType({
    listing,
    t,
    i18n
  });
  const materialItems = [{
    name: t('listing:ListingDetails.KitchenDescription'),
    value: kitchenDescription
  }, {
    name: t('listing:ListingDetails.KitchenFloorMaterial'),
    value: translateArrayWithHumanize({
      value: kitchenFloorMaterial,
      customValue: otherKitchenFloorMaterial,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.KitchenWallMaterial'),
    value: translateArrayWithHumanize({
      value: kitchenWallMaterial,
      customValue: otherKitchenWallMaterial,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.WorkTops'),
    value: translateArrayWithHumanize({
      value: kitchenWorkTop,
      customValue: otherKitchenWorkTop,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.KitchenEquipment'),
    value: getEquipmentAndAdditionalDetails({
      equipments: kitchenEquipment,
      details: kitchenEquipmentDetails,
      customValue: otherKitchenEquipment,
      translationKey: 'listing:KitchenEquipmentTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.StoveType'),
    value: translateArrayWithHumanize({
      value: stoveType,
      customValue: otherStoveType,
      translationKey: 'listing:StoveTypes.',
      t,
      i18n
    }),
    condition: !!stoveType
  }, {
    name: t('listing:ListingDetails.Bathroom'),
    value: bathroomDescription
  }, {
    name: t('listing:ListingDetails.BathroomWallMaterial'),
    value: translateArrayWithHumanize({
      value: bathroomWallMaterial,
      customValue: otherBathroomWallMaterial,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.BathroomFloorMaterial'),
    value: translateArrayWithHumanize({
      value: bathroomFloorMaterial,
      customValue: otherBathroomFloorMaterial,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.BathroomEquipment'),
    value: getEquipmentAndAdditionalDetails({
      equipments: bathroomEquipment,
      details: bathroomEquipmentDetails,
      customValue: otherBathroomEquipment,
      translationKey: 'listing:BathroomEquipmentTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.WCCount'),
    value: wcCount
  }, {
    name: t('listing:ListingDetails.WC'),
    value: wcDescription
  }, {
    name: t('listing:ListingDetails.WCFloorMaterial'),
    value: translateArrayWithHumanize({
      value: wcFloorMaterial,
      customValue: otherWcFloorMaterial,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.WCWallMaterial'),
    value: translateArrayWithHumanize({
      value: wcWallMaterial,
      customValue: otherWcWallMaterial,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.WCEquipment'),
    value: getEquipmentAndAdditionalDetails({
      equipments: wcEquipment,
      details: wcEquipmentDetails,
      customValue: otherWcEquipment,
      translationKey: 'listing:WCEquipmentValues.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.Bedrooms'),
    value: bedroomDescription
  }, {
    name: t('listing:ListingDetails.BedroomCount'),
    value: bedroomCount
  }, {
    name: t('listing:ListingDetails.BedroomWallMaterial'),
    value: translateArrayWithHumanize({
      value: bedroomWallMaterial,
      customValue: otherBedroomWallMaterial,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.BedroomFloorMaterial'),
    value: translateArrayWithHumanize({
      value: bedroomFloorMaterial,
      customValue: otherBedroomFloorMaterial,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.BedroomEquipment'),
    value: bedroomEquipment
  }, {
    name: t('listing:ListingDetails.Livingroom'),
    value: livingRoomDescription
  }, {
    name: t('listing:ListingDetails.LivingroomWallMaterial'),
    value: translateArrayWithHumanize({
      value: livingRoomWallMaterial,
      customValue: otherLivingRoomWallMaterial,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.LivingroomFloorMaterial'),
    value: translateArrayWithHumanize({
      value: livingRoomFloorMaterial,
      customValue: otherLivingRoomFloorMaterial,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.UtilityRoomEquipment'),
    value: getEquipmentAndAdditionalDetails({
      equipments: utilityRoomEquipment,
      details: utilityRoomEquipmentDetails,
      customValue: otherUtilityRoomEquipment,
      translationKey: 'listing:UtilityRoomEquipmentTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.UtilityRoomWallMaterial'),
    value: translateArrayWithHumanize({
      value: utilityRoomWallMaterial,
      customValue: otherUtilityRoomWallMaterial,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.UtilityRoomFloorMaterial'),
    value: translateArrayWithHumanize({
      value: utilityRoomFloorMaterial,
      customValue: otherUtilityRoomFloorMaterial,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.UtilityRoom'),
    value: utilityRoomDescription
  }, {
    name: t('listing:ListingDetails.UtilityRoomHasExit'),
    value: translateBoolean(utilityRoomHasExit, {
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.StorageRoom'),
    value: storageDescription
  }, {
    name: t('listing:ListingDetails.StorageSpaceTypes'),
    value: translateArrayWithHumanize({
      value: storageSpaceTypes,
      customValue: otherStorageSpaceTypes,
      translationKey: 'listing:StorageSpaceTypeValues.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.Sauna'),
    value: translateBoolean(sauna, {
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.SaunaStoveType'),
    value: translateArrayWithHumanize({
      value: saunaStoveType,
      customValue: otherSaunaStoveType,
      translationKey: 'listing:SaunaStoveValues.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.SaunaFloorMaterial'),
    value: translateArrayWithHumanize({
      value: saunaFloorMaterial,
      customValue: otherSaunaFloorMaterial,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.SaunaWallMaterial'),
    value: translateArrayWithHumanize({
      value: saunaWallMaterial,
      customValue: otherSaunaWallMaterial,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.SaunaDescription'),
    value: saunaDescription
  }, {
    name: t('listing:ListingDetails.Fireplace'),
    value: fireplaceType
  }];
  return /*#__PURE__*/React.createElement(DixuCard, {
    title: t('listing:ListingDetails.FacilitiesAndMaterials'),
    collapsible: ['mobile']
  }, /*#__PURE__*/React.createElement(DixuDescriptionList, {
    items: materialItems,
    filter: true,
    vertical: ['mobile']
  }));
};
const AdditionalInfoSection = _ref13 => {
  let {
    listing
  } = _ref13;
  const {
    t,
    i18n
  } = useTranslation(['common', 'listing']);
  const {
    accessible,
    accessibleInfo,
    hasBalcony,
    balconyCompassPoint,
    beach,
    otherBeach,
    beachInfo,
    bodyOfWater,
    condition,
    conditionInfo,
    floorMaterialInfo,
    hasCableTV,
    hasSatelliteAntenna,
    housingCooperativeElevator,
    inIsland,
    otherSpacesDescription,
    otherOtherSpacesDescription,
    otherSpacesInfo,
    ownBeachLine,
    roofMaterialInfo,
    terrace,
    view,
    wallMaterialInfo,
    yard,
    terraceInfo,
    importantInfoAffectingSale
  } = listing || {};
  const additionalInfoItems = [{
    name: t('listing:ListingDetails.ListingCondition'),
    value: t(`common:ConditionTypes.${condition}`),
    condition: !!condition
  }, {
    name: t('listing:ListingDetails.ListingConditionInfo'),
    value: conditionInfo
  }, {
    name: t('listing:ListingDetails.Views'),
    value: view
  }, {
    name: t('listing:ListingDetails.Balcony'),
    value: getBalconyDescription({
      listing,
      t,
      i18n
    }),
    condition: hasBalcony != null
  }, {
    name: t('listing:ListingDetails.BalconyDirection'),
    value: translateArrayWithHumanize({
      value: balconyCompassPoint,
      translationKey: 'listing:BalconyDirectionTypes.',
      t,
      i18n
    }),
    condition: !!balconyCompassPoint
  }, {
    name: t('listing:ListingDetails.BalconyArea'),
    value: t('common:Units.SquareMeters', {
      area: formatNumber(listing.balconyArea)
    }),
    condition: !!hasBalcony && listing.balconyArea != null
  }, {
    name: t('listing:ListingDetails.Terrace'),
    value: translateBoolean(terrace, {
      t,
      i18n
    })
  }, {
    condition: terrace,
    name: t('listing:ListingDetails.TerraceInfo'),
    value: terraceInfo
  }, {
    name: t('listing:ListingDetails.Yard'),
    value: yard
  }, {
    name: t('listing:ListingDetails.Beach'),
    value: getTranslationOrOther({
      value: beach,
      customValue: otherBeach,
      translationKey: 'listing:BeachTypes.',
      t,
      i18n
    }),
    condition: !!beach
  }, {
    name: t('listing:ListingDetails.OwnBeachLine'),
    value: ownBeachLine
  }, {
    name: t('listing:ListingDetails.BeachInfo'),
    value: beachInfo
  }, {
    name: t('listing:ListingDetails.Elevator'),
    value: translateBoolean(housingCooperativeElevator, {
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.BodyOfWater'),
    value: bodyOfWater
  }, {
    name: t('listing:ListingDetails.InIsland'),
    value: translateBoolean(inIsland, {
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.OtherSpaces'),
    value: otherSpacesInfo
  }, {
    name: t('listing:ListingDetails.OtherSpacesDescription'),
    value: translateArrayWithHumanize({
      value: otherSpacesDescription,
      customValue: otherOtherSpacesDescription,
      translationKey: 'listing:RoomValues.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.SurfaceMaterialWall'),
    value: wallMaterialInfo
  }, {
    name: t('listing:ListingDetails.SurfaceMaterialFloor'),
    value: floorMaterialInfo
  }, {
    name: t('listing:ListingDetails.SurfaceMaterialRoof'),
    value: roofMaterialInfo
  }, {
    name: t('listing:ListingDetails.DealIncludes'),
    value: getDealIncludes(listing, t)
  }, {
    name: t('listing:ListingDetails.DealDoesNotInclude'),
    value: getDealDoesNotInclude(listing, t)
  }, {
    name: t('listing:ListingDetails.HasSatelliteAntenna'),
    value: t(`common:BooleanTypesHas.${hasSatelliteAntenna}`),
    condition: hasSatelliteAntenna != null
  }, {
    name: t('listing:ListingDetails.HasCableTv'),
    value: t(`common:BooleanTypesHas.${hasCableTV}`),
    condition: hasCableTV != null
  }, {
    name: t('listing:ListingDetails.Accessible'),
    value: translateBoolean(accessible, {
      t,
      i18n
    }),
    condition: accessible != null
  }, {
    condition: accessible,
    name: t('listing:ListingDetails.AccessibleInfo'),
    value: accessibleInfo
  }, {
    name: t('listing:ListingDetails.ImportantInfoAffectingSale'),
    value: importantInfoAffectingSale
  }];
  return /*#__PURE__*/React.createElement(DixuCard, {
    title: t('listing:ListingDetails.Details'),
    collapsible: ['mobile']
  }, /*#__PURE__*/React.createElement(DixuDescriptionList, {
    items: additionalInfoItems,
    filter: true,
    vertical: ['mobile']
  }));
};
const PropertyInfoSection = _ref14 => {
  let {
    listing
  } = _ref14;
  const {
    t,
    i18n
  } = useTranslation(['common', 'listing']);
  const {
    asbestosSurvey,
    asbestosSurveyFromRealtor,
    asbestosSurveyInfo,
    carPortCount,
    conditionInvestigationDate,
    conditionInvestigationInfo,
    constructionMaterial,
    otherConstructionMaterial,
    constructionMaterialInfo,
    constructionPhase,
    electricPlugParkingSpaceCount,
    listingHasEnergyCertificate,
    energyCertificateValidity,
    energyClass,
    energyClassInfo,
    garageCount,
    housingCooperativeAdditionalInfo,
    housingCooperativeHas,
    otherHousingCooperativeHas,
    housingCooperativeHasDetails,
    housingCooperativeName,
    housingCooperativeParkingSpaces,
    housingCooperativeRedemptionRight,
    housingCooperativeRevenue,
    housingCooperativeSauna,
    humidityInvestigationDate,
    conditionCheckDate,
    includes,
    kindergarden,
    landRenter,
    landYearRent,
    landRedemptionPrice,
    localInfo,
    lotArea,
    lotInfo,
    lotOwnership,
    lotRentEndDate,
    lotSalesType,
    lotType,
    parkingGarageCount,
    parkingInfo,
    parkingSpace,
    parkingSpaceInfo,
    partnerRedemptionRight,
    propertyBuildingRights,
    propertyBuildingRightsENumber,
    propertyBuildingRightsInfo,
    propertyBuildings,
    otherPropertyBuildings,
    propertyBuildingsInfo,
    propertyHasAntenna,
    propertyAntennaDescription,
    propertyMaintenance,
    propertyMaintenanceInfo,
    propertyManagerEmail,
    propertyManagerName,
    propertyManagerOffice,
    propertyManagerPhone,
    propertySewer,
    propertyWaterPipe,
    restrictions,
    roadTo,
    roofCondition,
    roofingMaterial,
    otherRoofingMaterial,
    schools,
    services,
    servicesInfo,
    sewerInfo,
    trafficConnections,
    trafficConnectionsInfo,
    type,
    ventilation,
    waterPipeInfo,
    yardParkingSpaceCount,
    zoningDetails,
    zoningInfo,
    reportOnMaintenanceNeedsDate,
    reportOnMaintenanceNeedsInfo,
    housingCooperativeMortgage
  } = listing || {};
  const heatingSystem = getHeatingSystem({
    listing,
    t,
    i18n
  });
  const roofType = getRoofType({
    listing,
    i18n,
    t
  });
  const zoningStatus = getZoningStatus({
    listing,
    t,
    i18n
  });
  const housingCooperativeMortgageDate = getHousingCooperativeMortgageDate({
    listing,
    t
  });
  const propertyInfoItems = [{
    name: t('listing:ListingDetails.CompanyName'),
    value: housingCooperativeName
  }, {
    name: t('listing:ListingDetails.PropertyManager'),
    value: propertyManagerOffice
  }, {
    name: t('listing:ListingDetails.PropertyManagerName'),
    value: propertyManagerName
  }, {
    name: t('listing:ListingDetails.PropertyManagerEmail'),
    value: propertyManagerEmail ? /*#__PURE__*/React.createElement(DixuLink, {
      href: `mailto:${propertyManagerEmail}`
    }, propertyManagerEmail) : null
  }, {
    name: t('listing:ListingDetails.PropertyManagerTel'),
    value: propertyManagerPhone ? /*#__PURE__*/React.createElement(DixuLink, {
      href: `tel:${propertyManagerPhone}`
    }, propertyManagerPhone) : null
  }, {
    name: t('listing:ListingDetails.Revenue'),
    value: housingCooperativeRevenue
  }, {
    name: t('listing:ListingDetails.HousingCooperativeAdditionalInfo'),
    value: housingCooperativeAdditionalInfo
  }, {
    name: t(`listing:ListingDetails.LotArea`),
    value: getLotArea({
      listing,
      t
    }),
    condition: lotArea != null
  }, {
    name: t('listing:ListingDetails.LotOwnership'),
    value: t(`common:LotOwnershipTypes.${lotOwnership}`),
    condition: lotOwnership != null
  }, {
    name: t('listing:ListingDetails.LotType'),
    value: t(`listing:LotTypes.${lotType}`),
    condition: lotType != null
  }, {
    name: t('listing:ListingDetails.LotSalesType'),
    value: t(`listing:LotSalesTypes.${lotSalesType}`),
    condition: !!lotSalesType
  }, {
    name: t('listing:ListingDetails.PropertyLandRenter'),
    value: landRenter,
    condition: isLotOwnershipRentOrOptional(lotOwnership)
  }, {
    name: t('listing:ListingDetails.PropertyLotInfo'),
    value: lotInfo
  }, {
    name: t('listing:ListingDetails.PropertyYearlyLandRent'),
    value: formatPrice(landYearRent),
    condition: isLotOwnershipRentOrOptional(lotOwnership)
  }, {
    name: t('listing:ListingDetails.PropertyLotRentEndDate'),
    value: timestampToDay(lotRentEndDate),
    condition: isLotOwnershipRentOrOptional(lotOwnership)
  }, {
    name: t('listing:ListingDetails.PropertyLandRedemptionPrice'),
    value: formatPrice(landRedemptionPrice),
    condition: lotOwnership === LOT_OWNERSHIP.OPTIONAL
  }, {
    name: t('listing:ListingDetails.Restrictions'),
    value: restrictions
  }, {
    name: t('listing:ListingDetails.ConstructionMaterialDetails'),
    value: constructionMaterialInfo
  }, {
    name: t('listing:ListingDetails.ConstructionMaterial'),
    value: translateArrayWithHumanize({
      value: constructionMaterial,
      customValue: otherConstructionMaterial,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n,
      emptyAsNull: true
    })
  }, {
    name: t('listing:ListingDetails.HeatingSystem'),
    value: heatingSystem
  }, {
    name: t('listing:ListingDetails.Ventilation'),
    value: ventilation
  }, {
    name: t('listing:ListingDetails.WaterPipe'),
    value: propertyWaterPipe
  }, {
    name: t('listing:ListingDetails.WaterPipeInfo'),
    value: waterPipeInfo
  }, {
    name: t('listing:ListingDetails.Sewer'),
    value: propertySewer
  }, {
    name: t('listing:ListingDetails.SewerInfo'),
    value: sewerInfo
  }, {
    name: t('listing:ListingDetails.RoofType'),
    value: roofType
  }, {
    name: t('listing:ListingDetails.RoofCondition'),
    value: roofCondition
  }, {
    name: t('listing:ListingDetails.RoofMaterial'),
    value: getTranslationOrOther({
      value: roofingMaterial,
      customValue: otherRoofingMaterial,
      translationKey: 'listing:MaterialTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.PropertyBuildingRights'),
    value: propertyBuildingRights
  }, {
    name: t('listing:ListingDetails.BuildingRightsInfo'),
    value: propertyBuildingRightsInfo
  }, {
    name: t('listing:ListingDetails.BuildingRightsENumber'),
    value: propertyBuildingRightsENumber
  }, {
    name: t('listing:ListingDetails.PropertyMaintenance'),
    value: getTranslationOrOther({
      value: propertyMaintenance,
      translationKey: 'common:PropertyMaintenanceTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.PropertyMaintenanceInfo'),
    value: propertyMaintenanceInfo
  }, {
    name: t('listing:ListingDetails.PropertyHas'),
    value: getEquipmentAndAdditionalDetails({
      equipments: housingCooperativeHas,
      details: housingCooperativeHasDetails,
      customValue: otherHousingCooperativeHas,
      translationKey: 'listing:HousingCooperativeHas.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.HousingCooperativeRedemptionRight'),
    value: translateBoolean(housingCooperativeRedemptionRight, {
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.PartnerRedemptionRight'),
    value: translateBoolean(partnerRedemptionRight, {
      t,
      i18n
    })
  }, {
    name: listing.type === LISTING_TYPE.PROPERTY ? t('listing:ListingDetails.HasAntenna') : t('listing:ListingDetails.PropertyHasAntenna'),
    value: translateBoolean(propertyHasAntenna, {
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.PropertyAntennaDescription'),
    value: propertyAntennaDescription
  }, {
    name: t('listing:ListingDetails.EnergyCertificateExistsForListing'),
    value: getTranslationOrOther({
      value: listingHasEnergyCertificate,
      translationKey: 'listing:ListingDetails.ListingHasEnergyCertificateTypes.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.EnergyClass'),
    value: energyClass
  }, {
    name: t('listing:ListingDetails.EnergyCertificateValidity'),
    value: dateToFinnishFormat(energyCertificateValidity),
    condition: !!energyCertificateValidity
  }, {
    name: t('listing:ListingDetails.EnergyClassInfo'),
    value: energyClassInfo
  }, {
    name: t('listing:ListingDetails.Includes', {
      type: (() => {
        if (type === LISTING_TYPE.APARTMENT) {
          return t('listing:ListingDetails.ToHousingCoop');
        }
        if (type === LISTING_TYPE.PROPERTY) {
          return t('listing:ListingDetails.ToProperty');
        }
        return undefined;
      })()
    }),
    value: includes
  }, {
    name: t('listing:ListingDetails.TrafficConnections'),
    value: translateArrayWithHumanize({
      value: trafficConnections,
      translationKey: 'listing:TrafficConnectionValues.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.TrafficConnectionsInfo'),
    value: trafficConnectionsInfo
  }, {
    name: t('listing:ListingDetails.RoadTo'),
    value: translateBoolean(roadTo, {
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.LocalInfo'),
    value: localInfo
  }, {
    name: t('listing:ListingDetails.Services'),
    value: services
  }, {
    name: t('listing:ListingDetails.ServicesInfo'),
    value: servicesInfo
  }, {
    name: t('listing:ListingDetails.Schools'),
    value: schools
  }, {
    name: t('listing:ListingDetails.Kindergartens'),
    value: kindergarden
  }, {
    name: t('listing:ListingDetails.ParkingSpace'),
    value: translateArrayWithHumanize({
      value: parkingSpace,
      translationKey: 'listing:ParkingSpaceType.',
      t,
      i18n
    }),
    condition: !!parkingSpace
  }, {
    name: t('listing:ListingDetails.ParkingSpaceInfo'),
    value: parkingSpaceInfo
  }, {
    name: t('listing:ListingDetails.ApartmentParkingSpaces'),
    value: housingCooperativeParkingSpaces
  }, {
    name: t('listing:ListingDetails.PropertyParkingInfo'),
    value: parkingInfo
  }, {
    name: t('listing:ListingDetails.PropertyGarageCount'),
    value: garageCount
  }, {
    name: t('listing:ListingDetails.PropertyCarPortCount'),
    value: carPortCount
  }, {
    name: t('listing:ListingDetails.PropertyElectricPlugParkingSpaceCount'),
    value: electricPlugParkingSpaceCount,
    valueSuffix: t('common:Suffixes.Pcs')
  }, {
    name: t('listing:ListingDetails.PropertyYardParkingSpaceCount'),
    value: yardParkingSpaceCount,
    valueSuffix: t('common:Suffixes.Pcs')
  }, {
    name: t('listing:ListingDetails.PropertyParkingGarageCount'),
    value: parkingGarageCount,
    valueSuffix: t('common:Suffixes.Pcs')
  }, {
    name: t('listing:ListingDetails.HousingCoopSauna'),
    value: translateBoolean(housingCooperativeSauna, {
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.PropertyZoningStatus'),
    value: zoningStatus
  }, {
    name: t('listing:ListingDetails.PropertyZoningInfo'),
    value: zoningInfo,
    condition: type === LISTING_TYPE.APARTMENT
  }, {
    name: t('listing:ListingDetails.PropertyZoningDetails'),
    value: zoningDetails
  }, {
    name: t('listing:ListingDetails.PropertyConditionInvestigationInfo'),
    value: conditionInvestigationInfo
  }, {
    name: t('listing:ListingDetails.PropertyHumidityInvestigationDate'),
    value: timestampToDay(humidityInvestigationDate)
  }, {
    name: t('listing:ListingDetails.PropertyConditionCheckDate'),
    value: timestampToDay(conditionCheckDate)
  }, {
    name: t('listing:ListingDetails.PropertyConditionInvestigationDate'),
    value: timestampToDay(conditionInvestigationDate)
  }, {
    name: t('listing:ListingDetails.ReportOnMaintenanceNeedsYear'),
    value: reportOnMaintenanceNeedsDate
  }, {
    name: t('listing:ListingDetails.ReportOnMaintenanceNeedsInfo'),
    value: reportOnMaintenanceNeedsInfo
  }, {
    name: t('listing:ListingDetails.ConstructionPhase'),
    value: t(`listing:ConstructionPhases.${constructionPhase}`),
    condition: !!constructionPhase
  }, {
    name: t('listing:ListingDetails.AsbestosSurvey'),
    value: translateBoolean(asbestosSurvey, {
      t,
      i18n
    }) || translateBoolean(asbestosSurveyFromRealtor, {
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.AsbestosSurveyInfo'),
    value: asbestosSurveyInfo
  }, {
    name: t('listing:ListingDetails.PropertyBuildings'),
    value: translateArrayWithHumanize({
      value: propertyBuildings,
      customValue: otherPropertyBuildings,
      translationKey: 'listing:PropertyBuildings.',
      t,
      i18n
    })
  }, {
    name: t('listing:ListingDetails.PropertyBuildingsInfo'),
    value: propertyBuildingsInfo
  }, {
    name: t('listing:ListingDetails.HousingCooperativeMortgage'),
    value: formatPrice(housingCooperativeMortgage)
  }, {
    name: t('listing:ListingDetails.HousingCooperativeMortgageDate'),
    value: housingCooperativeMortgageDate
  }];
  return /*#__PURE__*/React.createElement(DixuCard, {
    id: "housing-coop",
    title: t('listing:ListingDetails.HousingCoopAndProperty'),
    collapsible: ['mobile']
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [48, 24]
  }, /*#__PURE__*/React.createElement(DixuDescriptionList, {
    items: propertyInfoItems,
    filter: true,
    columns: 2,
    colProps: {
      xs: 24,
      xl: 12
    },
    vertical: ['mobile']
  })));
};
const RenovationsAndFlawsDamagesSection = _ref15 => {
  let {
    listing
  } = _ref15;
  const {
    t,
    i18n
  } = useTranslation(['common', 'listing']);
  const {
    pastRenovations,
    housingCooperativeUpcomingRenovations
  } = listing || {};
  const pastRenovationsText = pastRenovations?.trim();
  const upcomingRenovationsText = housingCooperativeUpcomingRenovations?.trim();
  const flawsAndDamagesText = getFlawsAndDamages({
    listing,
    t,
    i18n
  });
  const isVisibleFlawsAndDamages = flawsAndDamagesText && listing?.servicePackage;
  if (!pastRenovationsText && !upcomingRenovationsText && !isVisibleFlawsAndDamages) {
    return null;
  }
  return /*#__PURE__*/React.createElement(DixuCard, {
    id: "renovations",
    containerProps: {
      horizontalPadding: false,
      verticalPadding: false
    }
  }, /*#__PURE__*/React.createElement(DixuRow, null, pastRenovationsText && /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: upcomingRenovationsText || flawsAndDamagesText ? 12 : 24
  }, /*#__PURE__*/React.createElement(DixuCard, {
    title: t('listing:ListingDetails.PastRenovations'),
    contentProps: {
      whiteSpace: 'pre-line'
    },
    collapsible: ['mobile']
  }, pastRenovationsText)), upcomingRenovationsText && /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: pastRenovationsText || flawsAndDamagesText ? 12 : 24
  }, /*#__PURE__*/React.createElement(DixuCard, {
    title: t('listing:ListingDetails.UpcomingRenovations'),
    contentProps: {
      whiteSpace: 'pre-line'
    },
    collapsible: ['mobile']
  }, upcomingRenovationsText)), isVisibleFlawsAndDamages && /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: pastRenovationsText || upcomingRenovationsText ? 12 : 24
  }, /*#__PURE__*/React.createElement(DixuCard, {
    title: t('listing:ListingDetails.FlawsAndDamages'),
    contentProps: {
      whiteSpace: 'pre-line'
    },
    collapsible: ['mobile']
  }, `${t('listing:ListingDetails.AwareOrKnowsThat')}:
                            
                            ${flawsAndDamagesText}
                            `))));
};
const DixuListingScreen = _ref16 => {
  let {
    listing,
    documents
  } = _ref16;
  const {
    user
  } = useContext(AppContext);
  const {
    t
  } = useTranslation(['common', 'listing']);
  const router = useRouter();
  const {
    query
  } = router || {};
  const {
    preview
  } = query || {};
  const gap = 16;
  const ifLoggedIn = cb => {
    if (user) {
      return cb?.();
    }
    redirect(`/rekisteroidy${toQueryString({
      referrerPath: getReferrerPath()
    })}`);
    return undefined;
  };
  const {
    city,
    floorPlans,
    freeText,
    housingCooperativeUpcomingRenovations,
    id,
    lifts,
    listingType,
    municipality,
    pastRenovations,
    servicePackage,
    status,
    thumbnails
  } = listing || {};
  const streetAddress = getStreetAddress(listing);
  const pastRenovationsText = pastRenovations?.trim();
  const upcomingRenovationsText = housingCooperativeUpcomingRenovations?.trim();
  const hasFlawsAndDamages = [listing.sellerAwareWaterDamage, listing.sellerAwareHumidityDamage, listing.sellerAwareMoldDamage, listing.sellerAwareWaterDamageLocation, listing.sellerAwareHumidityDamageLocation, listing.sellerAwareMoldDamageLocation].filter(Boolean);
  const hasRenovationsOrFlawsAndDamages = pastRenovationsText || upcomingRenovationsText || hasFlawsAndDamages;
  const hasFloorPlans = !!floorPlans?.length;
  const hasLifts = !!lifts?.length;
  const hasFloorPlanOrLifts = hasFloorPlans || hasLifts;
  const canPublish = servicePackage === SERVICE_PACKAGE.DIXU_EASY && status === LISTING_STATUS.READY_TO_PUBLISH;
  const metaDescription = freeText?.trim() ? truncate([streetAddress, replaceLineBreaks(freeText.trim())].filter(Boolean).join(': '), {
    length: 160
  }) : null;
  const [onPublishListing, isPublishingListing] = useIsLoading(async () => {
    try {
      await publishListing({
        listingID: id
      });
      router.replace(`/oma-dixu/myyntikohteet/${id}?tab=saleProcess&saleProcessTab=presentations`);
    } catch (error) {
      DixuNotification.error({
        message: 'Julkaiseminen epäonnistui',
        description: getErrorDescription(error)
      });
    }
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuHead, {
    title: [streetAddress, listingType ? t(`listing:Type.${listingType}`) : null, [municipality].includes(city) ? null : city, municipality].filter(Boolean).join(', '),
    titleAffixPosition: "end",
    description: metaDescription,
    image: thumbnails?.[0]
  }, /*#__PURE__*/React.createElement("link", {
    href: "https://api.tiles.mapbox.com/mapbox-gl-js/v1.6.1/mapbox-gl.css",
    rel: "stylesheet"
  })), /*#__PURE__*/React.createElement("div", {
    className: "dixu-listing-screen"
  }, /*#__PURE__*/React.createElement(HeroSection, {
    listing: listing,
    documents: documents,
    ifLoggedIn: ifLoggedIn
  }), /*#__PURE__*/React.createElement(DixuContainer, {
    verticalPadding: "lg"
  }, /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 16]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(ActionButtonsSection, {
    listing: listing,
    ifLoggedIn: ifLoggedIn
  })), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(SellerSection, {
    listing: listing,
    ifLoggedIn: ifLoggedIn
  })), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, gap],
    className: "drop-shadow-4"
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(MapSection, {
    listing: listing
  })), (freeText?.trim() || hasFloorPlanOrLifts) && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [gap, gap]
  }, freeText && /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: hasFloorPlanOrLifts ? 12 : 24
  }, /*#__PURE__*/React.createElement(IntroductionSection, {
    listing: listing
  })), hasFloorPlanOrLifts && /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: freeText ? 12 : 24,
    type: "flex"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, gap]
  }, hasFloorPlans && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(FloorPlansSection, {
    listing: listing
  })), hasLifts && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(LiftsSection, {
    listing: listing
  })))))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [gap, gap]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 12
  }, /*#__PURE__*/React.createElement(BasicInfoSection, {
    listing: listing
  })), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 12
  }, /*#__PURE__*/React.createElement(ExpensesSection, {
    listing: listing
  })), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 12
  }, /*#__PURE__*/React.createElement(FacilitiesAndMaterialsSection, {
    listing: listing
  })), /*#__PURE__*/React.createElement(DixuCol, {
    xs: 24,
    xl: 12
  }, /*#__PURE__*/React.createElement(AdditionalInfoSection, {
    listing: listing
  })))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(PropertyInfoSection, {
    listing: listing
  })), hasRenovationsOrFlawsAndDamages && /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(RenovationsAndFlawsDamagesSection, {
    listing: listing
  })))))))), preview && canPublish && /*#__PURE__*/React.createElement(DixuListingPublishControls, {
    onEdit: () => {
      router.push(`/oma-dixu/myyntikohteet/${id}?tab=listingDetails`);
    },
    onPublish: onPublishListing,
    disabled: isPublishingListing
  }));
};
DixuListingScreen.defaultProps = {
  documents: undefined
};
export default DixuListingScreen;